import React from 'react';

import {
    Grid,
    Button,
    Divider,
    Collapse
} from '@mui/material';
import {
    LocalShipping,
    CheckBox,
    CheckBoxOutlineBlank,
    ExpandMore,
    ExpandLess
} from '@mui/icons-material';

import { BoolField } from '@commonComponents/Form';
import { SectionDivider } from '@commonComponents';
import { TenantProfileType, METADATA_TYPES } from '@types';

interface VehicleBlockProps {
    onAllNone: ({ key, array }: { key: string; array: string[] }) => void;
    onClick: ({ key, value }: { key: string; value: string }) => void;
    settables: string[];
    vehicleTypes: TenantProfileType['vehicleTypes'];

}

const VehicleTypes: React.FC<VehicleBlockProps> = (props) => {
    const {
        onAllNone,
        onClick,
        settables = [],
        vehicleTypes = []
    } = props;

    const [collapsed, setCollapsed] = React.useState<boolean>(false);
    const [selected, setSelected] = React.useState<'all' | 'some' | 'none'>('some');
    const key = METADATA_TYPES.VEHICLE_TYPES;

    React.useEffect(() => {
        if (settables.every((veh) => vehicleTypes.includes(veh))) {
            setSelected('all');
        } else if (vehicleTypes.length === 0) {
            setSelected('none');
        } else {
            setSelected('some');
        }
    }, [vehicleTypes, settables]);

    const selectAll = () => {
        const newVeh = Array.from(new Set([...vehicleTypes, ...settables]));
        onAllNone({ key, array: newVeh });
    };

    const selectNone = () => {
        const newVeh = vehicleTypes.filter((veh: string) => !settables.includes(veh));
        onAllNone({ key, array: newVeh });
    };

    return (
        <Grid item xs={12} lg={6}>
            <SectionDivider
                label={(
                    <>
                        {`Fordonstyper  (${vehicleTypes.length}) `}
                        {collapsed ? <ExpandMore /> : <ExpandLess />}
                    </>
                )}
                icon={<LocalShipping fontSize="small" />}
                marginTop={0}
                marginBottom={2}
                onClick={() => setCollapsed(!collapsed)}
            />
            <Collapse in={!collapsed}>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectAll()}
                            startIcon={selected === 'all' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Alla
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectNone()}
                            startIcon={selected === 'none' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Inga
                        </Button>
                    </Grid>
                </Grid>
                <Divider sx={{ mb: 2, width: '160px' }} />
                <Grid container spacing={1}>
                    {settables.map((veh) => (
                        <Grid item xs={12} sm={6} md={4} key={veh}>
                            <BoolField
                                name={veh}
                                label={veh}
                                value={vehicleTypes.includes(veh)}
                                onChange={() => onClick({ key, value: veh })}
                                sx={{ py: 0.25 }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Collapse>
        </Grid>
    );
};

export default VehicleTypes;
